var handleFetchWindowSize = function handleFetchWindowSize(event, postMessageService) {
  var height = window.innerHeight;
  var width = window.innerWidth;
  var scrollY = window.scrollY;
  var offset = 0;
  var footer = 0;
  postMessageService.sendSuccessPostMessageResponse('lti.fetchWindowSize', {
    height: height,
    width: width,
    footer: footer,
    scrollY: scrollY,
    offset: offset
  }, event.source, event.origin);
};
export default handleFetchWindowSize;